module.exports = __webpack_public_path__ + "static/media/video-stress-en.b868df31.vtt";